import React__default from 'react';
import PropTypes from 'prop-types';
import Typography from '../Typography/index.js';

var variants = {
  large: 'bodyLarge',
  medium: 'bodyMedium',
  regular: 'bodyRegular',
  small: 'bodySmall'
};
var LabelBody = function LabelBody(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'regular' : _ref$size,
    _ref$htmlFor = _ref.htmlFor,
    htmlFor = _ref$htmlFor === void 0 ? undefined : _ref$htmlFor,
    children = _ref.children;
  return React__default.createElement(Typography, {
    htmlFor: htmlFor,
    variant: variants[size],
    as: "label"
  }, children);
};
LabelBody.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(variants))
};
var LabelBody$1 = LabelBody;

export { LabelBody$1 as default };
//# sourceMappingURL=LabelBody.js.map
